import { defaultSettings } from '../settings';

// ----------------------------------------------------------------------

export const schemeConfig = {
  modeStorageKey: 'themeMode',
  defaultMode: defaultSettings.colorScheme,
  classesPrefix: 'minimal',
};
